import { render, staticRenderFns } from "./final-questions.vue?vue&type=template&id=9fdd4d8e&scoped=true&"
import script from "./final-questions.vue?vue&type=script&lang=js&"
export * from "./final-questions.vue?vue&type=script&lang=js&"
import style0 from "./final-questions.vue?vue&type=style&index=0&id=9fdd4d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdd4d8e",
  null
  
)

export default component.exports